import { useFilterEmployeeIncidentContext } from "./filter-employee-incident.context";

export function FilterEmployeeIncident() {
  const { dateFilterElement, reportFilterElements, clearFiltersElement } =
    useFilterEmployeeIncidentContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {reportFilterElements}
      {clearFiltersElement}
    </div>
  );
}